import React from "react";
import { observer, inject } from 'mobx-react';
import { withRouter } from "react-router-dom";

import 'react-loading-bar/dist/index.css';


let config = require('../Config/appConfig.json');

let self = null;
var captcha = null;
var url = config.SHARE_URL;
var title = config.SHARE_TITLE;
var source = config.SHARE_SOURCE;

@inject("appStore")
@observer
class WebShare extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            
            showShare: "none"
        };
    }

    componentWillMount = () => {
        self = this;


    }




    addNotifiation = (type, message) => {
        window.sendNotification(type, message)

    }



    componentDidMount = () => {
                
    }

    
    goToTwitter = () => {
        var twitter_url = "https://twitter.com/intent/tweet?status=" + title + url;
        window.open(twitter_url, "_blank")
    }
    goToFacebook = () => {
        var fb_url = "https://www.facebook.com/share.php?u=" + url + "&title=" + title;
        window.open(fb_url, "_blank")
    }
    goToLinkedIn = () => {
        var linkedin_url = "https://www.linkedin.com/shareArticle?mini=true&url="+ url + "&title=" + title + "&source=" +source;
        window.open(linkedin_url, "_blank")
    }
    goToPinterest = () => {
        var pinterest_url = "https://pinterest.com/pin/create/bookmarklet/?media={{media}}" + "&url=" + url + "&is_video=false&description=" + title;
        window.open(pinterest_url, "_blank")
    }






    render() {

        return (
            // <div>
                <div id="share" style={{marginTop:'2%'}}>


                    <a class="facebook" href="javascript:void(0);" onClick={this.goToFacebook}><i class="fa fa-facebook"></i></a>


                    <a class="twitter" href="javascript:void(0);" onClick={this.goToTwitter}><i class="fa fa-twitter"></i></a>


                    <a class="linkedin" href="javascript:void(0);" onClick={this.goToLinkedIn}><i class="fa fa-linkedin"></i></a>


                    <a class="pinterest" href="javascript:void(0);" onClick={this.goToPinterest}><i class="fa fa-pinterest-p"></i></a>

                </div>
            // </div >
        );
    }
}

export default withRouter(WebShare);


// WEBPACK FOOTER //
// ./src/Pages/WebShare.js